import {Link, NavLink} from "react-router-dom";
import {
    FiHome,
    FiRepeat,
    FiCreditCard,
    FiTarget,
    FiFileText,

    FiSettings,
    FiDollarSign,
    FiX,
    FiLogOut,
} from "react-icons/fi";
import useAuth from "../../hooks/useAuth";
function getInitials(user) {
    const n = (user?.nombres || "").trim().charAt(0).toUpperCase();
    const a = (user?.apellidos || "").trim().charAt(0).toUpperCase();
    return `${n}${a}`.trim() || "U";
}
const items = [
    { to: "/", label: "Dashboard", icon: <FiHome /> },
    { to: "/movimientos", label: "Movimientos", icon: <FiRepeat /> },
    { to: "/cuentas", label: "Cuentas", icon: <FiCreditCard /> },
    { to: "/presupuestos", label: "Presupuestos", icon: <FiFileText /> },
    { to: "/metas", label: "Metas", icon: <FiTarget /> },
    { to: "/deudas", label: "Deudas", icon: <FiDollarSign /> },

    { to: "/configuracion", label: "Configuración", icon: <FiSettings /> },
];

export default function Sidebar({ mobileOpen = false, onClose }) {
    const { user, logout } = useAuth();

    return (
        <aside className={`sidebar ${mobileOpen ? "sidebar-open" : ""}`}>
            <div className="sidebar-header">
                <div className="sidebar-brand">Ahorro Pro</div>

                <button
                    type="button"
                    className="sidebar-close-btn"
                    onClick={onClose}
                >
                    <FiX size={22}/>
                </button>
            </div>

            <div className="sidebar-body">
                <nav className="sidebar-nav">
                    {items.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            onClick={onClose}
                            className={({isActive}) =>
                                `sidebar-link ${isActive ? "active" : ""}`
                            }
                        >
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </NavLink>
                    ))}
                </nav>
            </div>


            <div className="sidebar-profile-box">
                <Link to="/mi-perfil" className="sidebar-profile-link">
                    {user?.avatarUrl ? (
                        <img src={user.avatarUrl} alt="Perfil" className="sidebar-profile-avatar"/>
                    ) : (
                        <div className="sidebar-profile-fallback">{getInitials(user)}</div>
                    )}

                    <div className="sidebar-profile-text">
                        <strong>{`${user?.nombres || ""} ${user?.apellidos || ""}`.trim() || "Usuario"}</strong>
                        <span>{user?.email || ""}</span>
                    </div>
                </Link>
            </div>


            <div className="sidebar-footer">


                <button
                    type="button"
                    className="btn-danger sidebar-logout-btn"
                    onClick={logout}
                >
                    <FiLogOut size={16}/>
                    Cerrar sesión
                </button>
            </div>
        </aside>
    );
}